<div class="home">
  <zodi-home-shoe-banner></zodi-home-shoe-banner>

  <div class="page-container">
  <!-- Quick Navigation Cards -->
  <section class="quick-nav">
    <div class="nav-container">
      <h2>Shop by Category</h2>
      <div class="nav-grid">
        <mat-card class="nav-card sale" [routerLink]="['/products']" [queryParams]="{sale: 'true'}">
          <mat-card-header>
            <mat-icon>local_offer</mat-icon>
            <mat-card-title>Sale</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>Up to 70% Off</p>
          </mat-card-content>
        </mat-card>

        <mat-card
          class="nav-card clearance"
          [routerLink]="['/products']" 
          [queryParams]="{clearance: 'true'}"
        >
          <mat-card-header>
            <mat-icon>sell</mat-icon>
            <mat-card-title>Clearance</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>Final Reductions</p>
          </mat-card-content>
        </mat-card>

        <mat-card class="nav-card new-in" routerLink="/new-in">
          <mat-card-header>
            <mat-icon>fiber_new</mat-icon>
            <mat-card-title>New In</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>Latest Arrivals</p>
          </mat-card-content>
        </mat-card>

        <mat-card class="nav-card brands" routerLink="/products">
          <mat-card-header>
            <mat-icon>business</mat-icon>
            <mat-card-title>Brands</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>Premium Designers</p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </section>

  <!-- Featured Products -->
  <section class="featured-section">
    <zodi-featured-products></zodi-featured-products>
  </section>

  <!-- Brand Showcase -->
  <section class="brands-showcase">
    <div class="brands-container">
      <h2>Featured Brands</h2>
      <zodi-cold-start-loader *ngIf="loading" message="Loading brands and products..."></zodi-cold-start-loader>
      <div class="brand-logos-grid" *ngIf="!loading">
        <div
          class="brand-logo-card"
          *ngFor="let brand of featuredBrands"
          (click)="onBrandClick(brand.name)"
        >
          <div class="logo-container" *ngIf="shouldShowBrandLogo(brand)">
            <img
              [src]="brand.logo"
              alt=""
              class="brand-logo"
              (error)="onBrandLogoError(brand.name)"
            />
          </div>
          <h4>{{ brand.name }}</h4>
          <p>{{ getProductCountForBrand(brand.name) }} products</p>
        </div>
      </div>
    </div>
  </section>

  <!-- Promotional Banners -->
  <section class="promo-banners">
    <div class="promo-container">
      <div class="promo-grid">
        <mat-card class="promo-card seasonal">
          <mat-card-header>
            <mat-icon>ac_unit</mat-icon>
            <mat-card-title>Winter Collection</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>Cozy styles for the season</p>
            <span class="coming-soon-badge">Coming Soon!</span>
          </mat-card-content>
        </mat-card>

        <mat-card class="promo-card exclusive">
          <mat-card-header>
            <mat-icon>star</mat-icon>
            <mat-card-title>Exclusive Offers</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>Members only deals</p>
            <span class="coming-soon-badge">Coming Soon!</span>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </section>
  </div>
</div>
